import EventService from "../../../shared/services/EventService";
import { db } from "../../../shared/plugins/firebase-app";

const eventService = new EventService(db);
export default eventService;
